export default {
    section: 'Employee Information',
    name: 'employment-resources-employee-information',
    items: [
        {
            type: 'input-label',
            width: 12,
            props: {
                label: 'Please let us know the types of employees/contractors you currently have or will have in the future.  Please select all employment terms that apply and feel free to provide supplemental questions or information to help us determine the appropriate form agreements for your business.  SRG will then work with you to include/exclude any sample provisions you need.'
            }
        },
        {
            type: 'radio-list',
            text: 'W-2 Producing/Servicing Advisors (Employees)',
            name: 'employment-resources-employee-information-w2',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'checkbox-list',
                    text: 'Compensation',
                    name: 'employment-resources-employee-information-w2-compensation',
                    props: {
                        items: [
                            {
                                text: 'I would like to use my existing/custom compensation plan (will be attached as an exhibit)',
                                value: 'existing'
                            },
                            {
                                text: 'I would like to use and/or consider SRG\'s template compensation plan options',
                                value: 'template-compensation'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'checkbox-list',
                    text: 'Equity in Book of Business',
                    name: 'employment-resources-employee-information-w2-equity',
                    props: {
                        items: [
                            {
                                text: 'Existing boock of business brought to company at start date',
                                value: 'existing'
                            },
                            {
                                text: 'Family',
                                value: 'family'
                            },
                            {
                                text: 'New clients sourced by employee after start date',
                                value: 'new-clients'
                            },
                            {
                                text: 'Clients purchased by employee',
                                value: 'clients-purchased'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'checkbox-list',
                    text: 'Expense Reimbursement Options',
                    name: 'employment-resources-employee-information-w2-reimbursement',
                    props: {
                        items: [
                            {
                                text: 'Errors & omissions insurance',
                                value: 'errors-omissions'
                            },
                            {
                                text: 'Ticket charges',
                                value: 'ticket-charges'
                            },
                            {
                                text: 'Licenses, membership, and registration fees',
                                value: 'licenses-fees'
                            },
                            {
                                text: 'Other reasonable out-of-pocket expense subject to company policies',
                                value: 'out-of-pocket'
                            },
                            {
                                text: 'Education fees/costs',
                                value: 'education'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Subject to repayment in the event of termination?',
                    name: 'employment-resources-employee-information-w2-education-fee-repayment',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-employee-information-w2-reimbursement',
                                operator: 'contains',
                                value: 'education'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Repay if terminated within how many years?',
                    name: 'employment-resources-employee-information-w2-education-fee-repayment-time',
                    width: 3,
                    props: {
                        label: 'Years',
                        format: 'number'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-employee-information-w2-reimbursement',
                                operator: 'contains',
                                value: 'education'
                            },
                            {
                                name: 'employment-resources-employee-information-w2-education-fee-repayment',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Additional Notes',
                    name: 'employment-resources-employee-information-w2-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: '1099 Producing/Servicing Advisors (Contractors)',
            name: 'employment-resources-employee-information-1099',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'checkbox-list',
                    text: 'Compensation',
                    name: 'employment-resources-employee-information-1099-compensation',
                    props: {
                        items: [
                            {
                                text: 'I would like to use my existing/custom compensation plan (will be attached as an exhibit)',
                                value: 'existing'
                            },
                            {
                                text: 'I would like to use and/or consider SRG\'s template compensation plan options',
                                value: 'template-compensation'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-1099',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'checkbox-list',
                    text: 'Equity in Book of Business',
                    name: 'employment-resources-employee-information-1099-equity',
                    props: {
                        items: [
                            {
                                text: 'Existing boock of business brought to company at start date',
                                value: 'existing'
                            },
                            {
                                text: 'Family',
                                value: 'family'
                            },
                            {
                                text: 'New clients sourced by employee after start date',
                                value: 'new-clients'
                            },
                            {
                                text: 'Clients purchased by employee',
                                value: 'clients-purchased'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-1099',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'checkbox-list',
                    text: 'Expense Reimbursement Options',
                    name: 'employment-resources-employee-information-1099-reimbursement',
                    props: {
                        items: [
                            {
                                text: 'Errors & omissions insurance',
                                value: 'errors-omissions'
                            },
                            {
                                text: 'Ticket charges',
                                value: 'ticket-charges'
                            },
                            {
                                text: 'Licenses, membership, and registration fees',
                                value: 'licenses-fees'
                            },
                            {
                                text: 'Other reasonable out-of-pocket expense subject to company policies',
                                value: 'out-of-pocket'
                            },
                            {
                                text: 'Education fees/costs',
                                value: 'education'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-1099',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Subject to repayment in the event of termination?',
                    name: 'employment-resources-employee-information-1099-education-fee-repayment',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-1099',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-employee-information-1099-reimbursement',
                                operator: 'contains',
                                value: 'education'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Repay if terminated within how many years?',
                    name: 'employment-resources-employee-information-1099-education-fee-repayment-time',
                    width: 3,
                    props: {
                        label: 'Years',
                        format: 'number'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-1099',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-employee-information-1099-reimbursement',
                                operator: 'contains',
                                value: 'education'
                            },
                            {
                                name: 'employment-resources-employee-information-1099-education-fee-repayment',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Additional Notes',
                    name: 'employment-resources-employee-information-1099-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-1099',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'W-2 Executive/Administrative Employees',
            name: 'employment-resources-employee-information-w2-executive',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'checkbox-list',
                    text: 'Compensation',
                    name: 'employment-resources-employee-information-w2-executive-compensation',
                    props: {
                        items: [
                            {
                                text: 'I would like to use my existing/custom compensation plan (will be attached as an exhibit)',
                                value: 'existing'
                            },
                            {
                                text: 'I would like to use and/or consider SRG\'s template compensation plan options',
                                value: 'template-compensation'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2-executive',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'checkbox-list',
                    text: 'Expense Reimbursement Options',
                    name: 'employment-resources-employee-information-w2-executive-reimbursement',
                    props: {
                        items: [
                            {
                                text: 'Licenses, membership, and registration fees',
                                value: 'licenses-fees'
                            },
                            {
                                text: 'Other reasonable out-of-pocket expense subject to company policies',
                                value: 'out-of-pocket'
                            },
                            {
                                text: 'Education fees/costs',
                                value: 'education'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2-executive',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Subject to repayment in the event of termination?',
                    name: 'employment-resources-employee-information-w2-executive-education-fee-repayment',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2-executive',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-employee-information-w2-executive-reimbursement',
                                operator: 'contains',
                                value: 'education'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Repay if terminated within how many years?',
                    name: 'employment-resources-employee-information-w2-executive-education-fee-repayment-time',
                    width: 3,
                    props: {
                        label: 'Years',
                        format: 'number'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2-executive',
                                value: 'yes'
                            },
                            {
                                name: 'employment-resources-employee-information-w2-executive-reimbursement',
                                operator: 'contains',
                                value: 'education'
                            },
                            {
                                name: 'employment-resources-employee-information-w2-executive-education-fee-repayment',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Additional Notes',
                    name: 'employment-resources-employee-information-w2-executive-description',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'employment-resources-employee-information-w2-executive',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/employment-resources/valuation-data/employee-information.js